/**
 * Created by fers on 25.02.16.
 */

import Relay from 'react-relay';
import PropTypes from 'prop-types';
import { FlowInvocation } from '../../common/types/types';

interface InvokeFlowActionMutationProps {
    flowInvocation: FlowInvocation;
}

export default class InvokeFlowActionMutation extends Relay.Mutation<InvokeFlowActionMutationProps> {

    static propTypes = {
        flowInvocation: PropTypes.object.isRequired,
    };

    static fragments = {
        channel: () => Relay.QL`
              fragment on Flow {
                    organisation_id,
                    id,
              }
            `,
    };

    getMutation() {
        return Relay.QL`mutation {retryInvocation}`;
    }

    getFatQuery() {
        return Relay.QL`
            fragment on RetryInvocationPayload {
                flowInvocation {
                    id,
                    realId,
                    flow_id,
                    finished,
                    failed,
                    lastRun,
                    finishedAt,
                    status,
                    organisation_id,
                },
            }
        `;
    }

    getConfigs() {
        return [{
            type: 'REQUIRED_CHILDREN',
            children: [this.getFatQuery()],
        }];
    }

    getVariables() {
        return {
            flow_id: this.props.flowInvocation.flow_id,
            flowInvocation_id: this.props.flowInvocation.id,
            organisation_id: this.props.flowInvocation.organisation_id,
        };
    }
}
